/* global angular, _ */
module.exports = ['$scope', 'curriculumManager', 'bibContentManager', 'sriClient', '$stateParams', 'settings', '$state', 'termHelper', '$document', '$window', 'ngMeta',
  function ($scope, curriculumManager, bibContentManager, sriClient, $stateParams, settings, $state, termHelper, $document, $window, ngMeta) {
    'use strict';

    var offset = 120;
    function elmYPosition (eID) {
      var elm = document.getElementById(eID);
      if (! elm) {
        console.warn(eID + ' is not found');
      } else {
        var y = elm.offsetTop;
        var node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
          node = node.offsetParent;
          y += node.offsetTop;
        }
        return y;
      }
    }
    function elmYEndPosition (eID) {
      var elm = document.getElementById(eID);
      if (! elm) {
        console.warn(eID + ' is not found');
      } else {
        var y = elm.offsetTop + elm.offsetHeight;
        var node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
          node = node.offsetParent;
          y += node.offsetTop;
        }
        return y;
      }
    }

    $scope.$state = $state;

    if ($stateParams.from) {
      curriculumManager.getFieldByHref('/content/' + $stateParams.from
      ).then(function (field) {
        if (!field) {
          curriculumManager.getThemeByHref('/content/' + $stateParams.from
          ).then(function (theme) {
            if (!theme) {
              curriculumManager.getGoalByHref('/content/' + $stateParams.from
              ).then(function (goal) {
                if (goal) {
                  $scope.from = goal;
                  $scope.from.state = 'leerinhoud.goal';
                  $scope.from.params = {fieldKey: goal.theme.field.identifiers[0], themeKey: goal.theme.identifiers[0], goalKey: goal.identifiers[0]};
                }
              });
            } else {
              $scope.from = theme;
              $scope.from.state = 'leerinhoud.theme';
              $scope.from.params = {fieldKey: theme.field.identifiers[0], themeKey: theme.identifiers[0]};
            }
          });
        } else {
          $scope.from = field;
          $scope.from.state = 'leerinhoud.field';
          $scope.from.params = {fieldKey: field.identifiers[0]};
        }
      });
    }
    $scope.loading = true;

    $scope.loading = true;
    bibContentManager.getContent('/content/' + $stateParams.key).then(function (result) {
      $scope.content = result;
      $scope.attachments = [];
      $scope.links = [];

      console.log(result);
      ngMeta.setTitle(result.title);
      ngMeta.setTag('description', result.description);
      if(result.thumbnail && result.thumbnail.href.indexOf('undefined') == -1) {
        result.thumb = settings.apisAndUrls.cachedApi + result.thumbnail.href;
      }
      $scope.loading = false;

      //LINKS
      $scope.links = result.links || [];
      $scope.footnotes = [];
      result.goals = [];
      result.fields = [];
      result.themes = [];

      result.$$relationsTo.forEach(function (relation) {
        var relationKey = relation.$$expanded.from.href.split('/')[relation.$$expanded.from.href.split('/').length - 1];
        curriculumManager.getFieldByHref('/content/' + relationKey).then(function (value) {
          var field;
          if (typeof value !== 'undefined') {
            field = value;
            field.title = termHelper.highlightTerm(field.title);
            if(result.fields.indexOf(field) === -1) {
              result.fields.push(field);
            }
          }
        });
        curriculumManager.getThemeByHref('/content/' + relationKey).then(function (value) {
          var theme;
          if (typeof value !== 'undefined') {
            theme = value;
            theme.title = termHelper.highlightTerm(theme.title);
            if(result.themes.indexOf(theme) === -1) {
              result.themes.push(theme);
            }
          }
        });
        curriculumManager.getSelection('/content/' + relationKey).then(function (value) {
          var goal, obj;
          if (value) {
            obj = value;
            if (obj.content2) {
              goal = obj.content2.content1.contentGroup.goal;
            } else if (obj.content1) {
              goal = obj.content1.contentGroup.goal;
            } else if (obj.leerlijn) {
              if (obj.leerlijn.content2) {
                goal = obj.leerlijn.content2.content1.contentGroup.goal;
              } else if (obj.leerlijn.content1) {
                goal = obj.leerlijn.content1.contentGroup.goal;
              } else {
                goal = obj.leerlijn.goal;
              }
            } else {
              goal = obj;
            }
            if(result.goals.indexOf(goal) === -1) {
              result.goals.push(goal);
            }
          }
        });
        $scope.loading = false;

      });

      scollListner();
    }, function () {
      $state.go('notFound', {}, { location: false });
    });

    $scope.goLevel1 = function (key) {
      window.scrollTo(0, elmYPosition(key) - offset + 1);
    };

    var scollListner = function (e) {
      var viewItem = $scope.content;
      if ($scope.content) {
        viewItem.contents.filter(o => o.type === 'SECTION').forEach(function (content) {
          content.prevPosition = elmYPosition(content.key) - 1;
          content.nextPosition = elmYEndPosition(content.key);
        });

        const position = $window.scrollY;
        if (viewItem && viewItem.contents) {
          $scope.selected = viewItem.contents.filter(function (o) {
            return o.prevPosition < position + offset && o.nextPosition > position + offset && o.type === 'SECTION';
          })[0];

          if ($scope.selected) {
            $scope.selected = $scope.selected.key;
          }

          if($scope.attachments.length > 0 && elmYEndPosition('downloads') > position + offset && elmYPosition('downloads') < position + offset) {
            $scope.current = 'downloads';
            $scope.selected = null;
          } else if($scope.content.contents.length > 0 && elmYEndPosition('toelichting') > position + offset && elmYPosition('toelichting') < position + offset) {
            $scope.current = 'toelichting';
          } else if($scope.links.length > 0 && elmYEndPosition('links') > position + offset && elmYPosition('links') < position + offset) {
            $scope.current = 'links';
            $scope.selected = null;
          } else if(($scope.content.goals.length > 0 || $scope.content.fields.length > 0 || $scope.content.themes.length > 0  ) && elmYEndPosition('found') > position + offset && elmYPosition('found') < position + offset) {
            $scope.current = 'found';
            $scope.selected = null;
          } else if($scope.footnotes.length > 0 && elmYEndPosition('bronnen') > position + offset && elmYPosition('bronnen') < position + offset) {
            $scope.current = 'bronnen';
            $scope.selected = null;
          } else {
            $scope.current = null;
            $scope.selected = null;
          }
          //$scope.$apply();
        }
      }
    };

    $document.on('scroll', scollListner);

    $scope.$on('$destroy', function () {
      $document.off('scroll', scollListner);
    });

  }
];



// WEBPACK FOOTER //
// ./web/js/screen/bib/search/term/display/bibSearchTermDisplayController.js